import { FC } from 'react';

import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';

interface RadioDisplay {
    label: string;
    value: boolean;
}

export const RadioDisplay: FC<RadioDisplay> = ({ label, value }) => (
    <Flex alignItems="center">
        <Typography fontSize="14px" color="#575757" marginRight="16px">
            {label}
        </Typography>

        <RadioGroup
            aria-labelledby="business-information-radio-buttons"
            name="business-information-radio-group"
            row
            defaultValue={value}
        >
            <FormControlLabel
                value={true}
                control={<Radio sx={{ color: '#F39E4E' }} />}
                label="Yes"
                disabled
            />
            <FormControlLabel
                value={false}
                control={<Radio sx={{ color: '#F39E4E' }} />}
                label="No"
                disabled
            />
        </RadioGroup>
    </Flex>
);
